export enum TypeOfVessels {
  TYPE_CONTAINER = 'container',
  TYPE_BULK = 'bulk',
  TYPE_TANKER = 'tanker',
  TYPE_RORO = 'roro',
  TYPE_GENERAL_CARGO = 'general_cargo',
  TYPE_MULTIPURPOSE = 'multipurpose',
}
